<div class="series-container">
    <div class="row">
        <div class="col-action"></div>
        <div class="col-action-delete"></div>
        <div class="col-pid"></div>
        <div class="col-patient"></div>
        <div class="col-description">{{ series.description }}</div>
        <div class="col-acc-number"></div>
        <div class="col-date">{{ series.date | date: "dd/MM/YYYY" }} {{ series.time }}</div>
        <div class="col-modality">{{ series.modality }}</div>
    </div>
</div>
